import { ClientInterface } from "."

interface ElementInterface {
    label: string,
    field: keyof ClientInterface
}

export const elements: ElementInterface[] = [
    {
        label: 'CEP',
        field: 'cep',
    },
    {
        label: 'Logradouro',
        field: 'street',
    },
    {
        label: 'Bairro',
        field: 'neighborhood',
    },
    {
        label: 'Estado',
        field: 'state',
    },
    {
        label: 'Cidade',
        field: 'city',
    },
    {
        label: 'Complemento',
        field: 'complement',
    },
    {
        label: 'Número',
        field: 'number',
    },
    {
        label: 'Dias',
        field: 'days',
    },
    {
        label: 'Horário',
        field: 'hours',
    }
]